<template>
  <div>
    <FiltersClaim :filters="filters" @close="posFilters" />
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row pb-2">
            <div class="col-6 col-md-6">
              <div class="row align-items-center">
                <div class="ml-2 mr-3">
                  <b-button
                    v-b-modal.modal-filters-claim
                    class="ml-2"
                    variant="success"
                  >
                    Filtros</b-button
                  >
                </div>

                <div class="col-2 m-0">Mostrar&nbsp;</div>
                <div class="col-3 m-0 p-0">
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </div>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-2">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Pesquisar..."
                    class="form-control form-control-sm"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>

          <div class="row pb-2">
            <div class="col-12">
              <div class="claim-list-quick-filter-list">
                <label class="claim-list-quick-filter-item">
                  <input
                    type="checkbox"
                    :checked="isAllQuickFilterSelected"
                    @change="selectAllQuickFilter"
                  />
                  Todas
                </label>
                <label
                  v-for="value in progressStatusValues"
                  :key="value"
                  class="claim-list-quick-filter-item"
                >
                  <input
                    type="checkbox"
                    :value="value"
                    v-model="filters.progress_status"
                    @change="onProgressStatusQuickFilterChange"
                  />
                  {{ getProgressStatusLabel(value) }}
                </label>
                <label class="claim-list-quick-filter-item">
                  <input
                    type="checkbox"
                    :checked="filters.is_tagged === 'true'"
                    @change="onIsTaggedQuickFilterChange"
                  />
                  Reclame Aqui
                </label>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div
                v-if="claims.length > 0 && !loading"
                class="table-responsive mb-0"
              >
                <b-table
                  :items="claims"
                  :fields="fields"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  sort-icon-left
                  :filter-included-fields="filterOn"
                >
                  <!-- :filter="filter" -->

                  <template v-slot:cell(status)="data">
                    <div v-if="data.item.progress_status" class="claim-list-progress-status-text">
                      <span
                        class="claim-list-progress-status-dot"
                        :class="'claim-list-' + getProgressStatusVariant(data.item.progress_status)"
                      ></span>
                      {{ getProgressStatusLabel(data.item.progress_status) }}
                    </div>
                    <div v-if="data.item.progress_status && data.item.status" class="claim-list-status-subtext">
                      Status: {{ getClaimStatusLabel(data.item.status) }}
                    </div>
                    <div v-if="!data.item.progress_status && data.item.status">{{ getClaimStatusLabel(data.item.status) }}</div>
                    <div v-if="!data.item.progress_status && !data.item.status">
                      Sem resposta
                    </div>
                  </template>

                  <template v-slot:cell(client)="data">
                    <template v-if="data.item.client">
                      <b>{{ data.item.client.name || '-' }}</b>
                      <div>{{ data.item.client.cpf_cnpj || '-' }}</div>
                      <div>{{ data.item.client.email || '-' }}</div>
                      <div v-if="data.item.client.cellphone">
                        <a
                          :href="`https://api.whatsapp.com/send?phone=+55${data.item.client.cellphone.replace(/[() -]/g, '')}`"
                          target="_blank"
                        >
                          <i class="fab fa-whatsapp"></i>
                          {{ data.item.client.cellphone }}
                        </a>
                      </div>
                    </template>
                    <template v-else>
                      <div>Cliente não informado</div>
                    </template>
                  </template>

                  <template v-slot:cell(sale)="data">
                    <b v-if="data">#{{ data.item.sale.id }}</b>
                    <div v-if="data.item.sale.paid_at">{{
                      data.item.sale.paid_at | datetimeUtc
                    }}</div>
                    <div v-if="data.item.sale.warranty"
                      >{{ data.item.sale.warranty }} Dias de Garantia</div
                    >
                    <div>{{ data.item.sale.name }}</div>
                    <div>{{ getStatus(data.item.sale.status).text }}</div>
                    <div v-if="data.item">
                      {{ isHeaven ? '$' : 'R$' }} {{ formatMoney(data.item.sale.amount) }}
                    </div>
                  </template>

                  <template v-slot:cell(claim)="data">
                    <b v-if="data">{{ data.item.subjective }}</b>
                    <div>{{ data.item.objective }}</div>
                  </template>

                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>

                  <template v-slot:cell(due)="data">
                    <span
                      v-if="data.item.deadline_passed || hasOverdueTag(data.item)"
                      class="due-date"
                    >
                      Vencido
                    </span>
                    <span v-else class="no-due-date">Ok </span>
                  </template>

                  <template v-slot:cell(tag)="data">
                    <span v-if="data.item.is_tagged === 1" class="tag btn-info">
                      reclame.aqui
                    </span>
                  </template>

                  <template v-slot:cell(_actions)="data">
                    <div class="actions">
                      <b-button
                        v-b-tooltip.hover title="Ver detalhes"
                        variant="dark"
                        :disabled="!canViewClaimDetails"
                        @click="openModalViewClaim(data.item)"
                      >
                        <i class="fas fa-info-circle"></i>
                      </b-button>
                      <b-button
                        :disabled="!canTagClaim"
                        v-b-tooltip.hover :title="data.item.is_tagged === 1 ? 'Remover a tag reclame.aqui' : 'Adicionar a tag reclame.aqui'"
                        :variant="data.item.is_tagged === 1 ? 'danger' : 'success'"
                        @click="tagClaim(data.item)"
                      >
                        <i class="fas fa-tag"></i>
                      </b-button>
                      <!-- <b-button
                        v-if="
                          (data.item.deadline_passed && !data.item.status) ||
                          data.item.status === 'refund_pending'
                        "
                        variant="dark"
                        @click="refundClaim(data.item)"
                      >
                        <i class="fas fa-wallet"></i>
                      </b-button> -->
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-if="claims.length > 0" class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

          <div
            v-if="claims.length === 0 && !loading"
            class="row justify-content-center"
          >
            <div class="alert alert-primary" role="alert">
              Sem produtos pendentes.
            </div>
          </div>
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>
    <ModalDetails :dados-user="dataUser" @deny="deny" />
    <b-modal id="modal-view-claim" size="lg" hide-footer>
      <FormViewClaim
        ref="formViewClaim"
        :dados="dadosClaimGet"
        :can-tag-claim="canTagClaim"
        :can-refund-claim="canRefundClaims"
        @tagClaim="tagClaim"
        @refundClaim="refundClaim"
        @list-claim="onListClaim"
      />
    </b-modal>

    <BankAccount @submit="refundClaimBoleto" />
  </div>
</template>

<script>
import Vue from 'vue'
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import ClaimService from '@services/resources/ClaimService'
import Money from '@src/mixins/money'
import FiltersClaim from '@components/claim/filters'
import FormViewClaim from '@components/claim/ViewClaim'
import _ from 'lodash'
import ModalDetails from './modal-details.vue'
import moment from 'moment'
import BankAccount from '../refunds/bankAccount.vue'
import validAcessRoute from '@/src/utils/validAcessRoute'
import {AccessLevel} from "@views/configurations/enums/accessLevel";

var service = ClaimService.build()

export default {
  page: {
    title: 'Reclamações',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    ModalDetails,
    FormViewClaim,
    FiltersClaim,
    BankAccount,
  },
  mixins: [Money],
  data() {
    return {
      dadosClaimGet: {
        s_id: null,
        id: null,
        doc: null,
      },
      success: validAcessRoute(['success'], this.$store.getters.getProfile),
      attendance: validAcessRoute(
        ['attendance'],
        this.$store.getters.getProfile
      ),
      risco: validAcessRoute(['risk'], this.$store.getters.getProfile),
      id_refund_item: null,
      status: null,
      moment: moment,
      dataUser: [],
      title: 'Reclamações',
      claims: [],
      solicitation: {},
      loading: true,
      items: [
        { text: 'Início', href: '/' },
        { text: 'Reclamações', active: true }
      ],
      totalRows: 1,
      currentPage: 1,
      total: 0,
      totalToPaid: 0,
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: '',
      filterOn: [],
      progressStatusValues: ['AWAITING_3DU', 'OUT_OF_WARRANTY', 'IN_PROGRESS', 'AUTO_CLOSED', 'CLOSED'],
      filters: {
        type: null,
        event: null,
        id: null,
        id_reclame_aqui: null,
        status: ['not_closed'],
        progress_status: [],
        overdue: null,
        is_tagged: null,
        ...this.defaultDateRange(),
      },
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'id_reclame_aqui', label: 'ID ReclameAqui', sortable: false },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'created_at', label: 'Data de Criação', sortable: false },
        { key: 'client', label: 'Cliente', sortable: false },
        { key: 'sale', label: 'Venda', sortable: false },
        { key: 'claim', label: 'Reclamação', sortable: true },
        { key: 'due', label: 'Prazo', sortable: false },
        { key: 'tag', label: 'Tag', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    canViewClaimDetails() {
      if (!this.useActionPermissions) return true;
      return this.$canAction('claims_show_details', AccessLevel.READER)
    },
    canTagClaim() {
      if (!this.useActionPermissions) return true;
      return this.$canAction('claims_tagged_button', AccessLevel.EDITOR)
    },
    canRefundClaims() {
      if (!this.useActionPermissions) return true;
      return this.$canAction('claims_refund_button', AccessLevel.EDITOR)
    },
    isAllQuickFilterSelected() {
      return this.filters.progress_status.length === 0 && this.filters.is_tagged !== 'true'
    },
  },
  watch: {
    currentPage() {
      const hasStoredFilters = localStorage.getItem('filter_claim') !== null && localStorage.getItem('filter_claim') !== '{}'
      const hasStoredSearch = localStorage.getItem('search_claim') !== null
      
      if (hasStoredFilters || hasStoredSearch) {
        this.fetchClaims(this.filters)
      } else {
        this.fetchClaims()
      }
    },
    perPage() {
      const hasStoredFilters = localStorage.getItem('filter_claim') !== null && localStorage.getItem('filter_claim') !== '{}'
      const hasStoredSearch = localStorage.getItem('search_claim') !== null
      
      if (hasStoredFilters || hasStoredSearch) {
        this.fetchClaims(this.filters)
      } else {
        this.fetchClaims()
      }
    },
    filter() {
      this.debounce()
    },
  },
  destroyed() {
    localStorage.removeItem('filter_claim', {})
    localStorage.removeItem('search_claim')
    localStorage.removeItem('page_claim')
  },
  beforeDestroy() {
    localStorage.removeItem('filter_claim', {})
    localStorage.removeItem('search_claim')
    localStorage.removeItem('page_claim')
  },
  mounted() {
    this.loadFiltersFromStorage()
    this.initClaim()
  },
  methods: {
    defaultDateRange() {
      return {
        date_start: moment().utcOffset(-180).subtract(2, 'months').endOf('month').format('YYYY-MM-DDTHH:mm:ssZ'),
        date_end: moment().utcOffset(-180).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
      }
    },
    persistFilters() {
      const persisted = { ...this.filters }
      delete persisted.date_start
      delete persisted.date_end

      localStorage.setItem('filter_claim', JSON.stringify(persisted))
    },

    loadFiltersFromStorage() {
      const savedFilters = localStorage.getItem('filter_claim')
      if (savedFilters && savedFilters !== '{}') {
        try {
          const parsedFilters = JSON.parse(savedFilters)
          this.filters = {
            type: parsedFilters.type || null,
            event: parsedFilters.event || null,
            id: parsedFilters.id || null,
            id_reclame_aqui: parsedFilters.id_reclame_aqui || null,
            status: parsedFilters.status || ['not_closed'],
            progress_status: parsedFilters.progress_status || [],
            overdue: parsedFilters.overdue || null,
            is_tagged: parsedFilters.is_tagged || null,
            ...this.defaultDateRange(),
          }
        } catch (error) {
          console.error('Error parsing saved filters:', error)
          this.resetFilters()
        }
      }
    },
    
    resetFilters() {
      this.filters = {
        type: null,
        event: null,
        id: null,
        id_reclame_aqui: null,
        status: ['not_closed'],
        progress_status: [],
        overdue: null,
        is_tagged: null,
        ...this.defaultDateRange(),
      }
    },

    async onListClaim() {
      await this.fetchClaims(this.filters)
    },
    initClaim() {
      const hasStoredFilters = localStorage.getItem('filter_claim') !== null && localStorage.getItem('filter_claim') !== '{}'
      const hasStoredSearch = localStorage.getItem('search_claim') !== null
      
      this.currentPage = parseInt(localStorage.getItem('page_claim')) || 1
      
      if (hasStoredSearch) {
        this.filter = localStorage.getItem('search_claim')
      }

      if (typeof this.$route.query.s_id !== 'undefined') {
        this.sale_id = this.$route.query.s_id
        
        if (hasStoredFilters || hasStoredSearch) {
          this.fetchClaims(this.filters)
        } else {
          this.fetchClaims()
        }
        
        setTimeout(() => {
          this.$bvModal.show('modal-view-claim')
          this.loading = false
        }, 1000)
      } else {
        if (hasStoredFilters || hasStoredSearch) {
          this.fetchClaims(this.filters)
        } else {
          this.fetchClaims()
        }
      }
    },
    getStatus(status) {
      if (status) {
        switch (status.toLowerCase()) {
          case 'processing': return { text: 'Processando', class: 'is-light-blue' }
          case 'authorized': return { text: 'Transação autorizada', class: 'is-light-blue' }
          case 'paid': return { text: 'Pago', class: 'is-green' }
          case 'refunded': return { text: 'Estornado', class: 'is-red' }
          case 'waiting_payment': return { text: 'Aguardando pagamento', class: 'is-warning' }
          case 'pending_approbation': return { text: 'Liberação manual', class: 'is-light-blue' }
          case 'pending_refund':
          case 'refund_pending': return { text: 'Reembolso pendente', class: 'is-warning' }
          case 'refused': return { text: 'Rejeitado', class: 'is-red' }
          case 'chargedback': return { text: 'Estorno', class: 'is-warning' }
          case 'delayed': return { text: 'Em processamento', class: 'is-warning' }
          default: return { text: status, class: 'is-black' }
        }
      } else return { text: status, class: 'is-black' }
    },
    getClaimStatusLabel(status) {
      if (!status) return 'Sem resposta'

      switch (status) {
        case 'close': return 'Encerrada'
        case 'close_solicitation': return 'Solicitação de encerramento'
        case 'waiting_answer_seller': return 'Aguardando resposta do Vendedor'
        case 'waiting_answer_client': return 'Aguardando resposta do Cliente'
        case 'refund_pending': return 'Solicitação de reembolso'
        case 'refunded': return 'Reembolsado'
        case 'refunded_automatically': return 'Reembolso automático'
        case 'refund_denied': return 'Reembolso negado'
        case 'in_analysis': return 'Em análise'
        default: return status
      }
    },
    getProgressStatusLabel(progressStatus) {
      switch (progressStatus) {
        case 'AWAITING_3DU': return 'Aguardando 3DU'
        case 'OUT_OF_WARRANTY': return 'Fora do prazo de garantia'
        case 'IN_PROGRESS': return 'Em tratativa'
        case 'AUTO_CLOSED': return 'Encerrada automaticamente'
        case 'CLOSED': return 'Encerrada'
        default: return progressStatus
      }
    },
    getProgressStatusVariant(progressStatus) {
      switch (progressStatus) {
        case 'AWAITING_3DU': return 'progress-status-primary'
        case 'OUT_OF_WARRANTY': return 'progress-status-warning'
        case 'IN_PROGRESS': return 'progress-status-info'
        case 'AUTO_CLOSED': return 'progress-status-secondary'
        case 'CLOSED': return 'progress-status-dark'
        default: return 'progress-status-secondary'
      }
    },
    hasOverdueTag(item) {
      return !!item.overdue
    },
    tagClaim(dados) {
      if (!this.canTagClaim) {
        this.$bvToast.toast('Você não tem permissão para alterar a tag desta reclamação.', {
          title: 'Acesso Negado',
          variant: 'warning',
          autoHideDelay: 5000,
        });
        return;
      }
      
      if (dados.is_tagged === 1) {
        Vue.swal({
          title: 'Deseja remover a tag reclame.aqui?',
          text: '',
          type: 'error',
          showCancelButton: true,
          confirmButtonText: 'Remover Tag',
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-danger mt-2 mr-2',
          cancelButtonClass: 'btn btn-info mt-2',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            service
              .create({}, null, `/tagged/${dados.id}?is_tagged=0`)
              .then(() => {
                this.$bvModal.hide('modal-view-claim')
                this.fetchClaims()
              })
              .catch(() => {})
          }
        })
      } else {
        Vue.swal({
          title:
            'Deseja adicionar a tag do Reclame Aqui? Por favor inserir o ID abaixo!',
          text: '',
          type: 'success',
          showCancelButton: true,
          confirmButtonText: 'Adicionar',
          input: 'number',
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success mt-2 mr-2',
          cancelButtonClass: 'btn btn-info mt-2',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            console.log(result)
            service
              .create(
                {},
                null,
                `/tagged/${dados.id}?is_tagged=1&id_reclame_aqui=${result.value}`
              )
              .then(() => {
                this.$bvModal.hide('modal-view-claim')
                this.fetchClaims()
              })
              .catch(() => {})
          } else {
            this.$bvToast.toast(
              'Necessario adicionar o ID. Preecha corretamente',
              {
                title: 'Reclame Aqui',
                variant: 'danger',
                autoHideDelay: 5000,
                appendToast: true,
              }
            )
            return false
          }
        })
      }
    },
    openModalViewClaim(item) {
      // this.$router.push({
      //   // query: { s_id: item.sale_id, id: item.id, doc: item.client.cpf_cnpj },
      //   query: { teste: 1 },
      // })

      this.dadosClaimGet = {
        s_id: item.sale_id,
        id: item.id,
        doc: (item.client && item.client.cpf_cnpj) || null,
      }

      setTimeout(() => {
        this.$bvModal.show('modal-view-claim')
      }, 200)
    },
    publicStatus(id, status) {
      Vue.swal({
        title: `${status ? 'Mostrar' : 'Bloquear'} na Vitrine`,
        text: `Tem certeza que deseja ${
          status ? 'Mostrar' : 'Bloquear'
        } esse produto da vitrine?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${status ? 'Mostrar' : 'Bloquear'}`,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: id,
            is_public_allowed: status,
          }
          service.update(data).then(() => {
            this.$bvModal.hide('details')
            this.fetchClaims()
          })
        }
      })
    },
    getTypeProduct(type) {
      let t = ''
      if (type) {
        switch (type.toUpperCase()) {
          case 'INFOPRODUCT': {
            t = 'Info Produto'
            break
          }
          case 'SERVICE': {
            t = 'Serviço'
            break
          }
          case 'PHYSICALPRODUCT': {
            t = 'Produto Físico'
            break
          }
          case 'EVENT': {
            t = 'Evento'
            break
          }
          case 'OTHERS': {
            t = 'Outros'
            break
          }
          default: {
            t = type
            break
          }
        }
        return t
      } else return type
    },
    debounce: _.debounce(function () {
      localStorage.setItem('search_claim', this.filter)
      this.fetchClaims()
    }, 500),
    
    posFilters(filters) {
      this.filters = { ...filters }
      this.persistFilters()
      this.fetchClaims(this.filters)
    },
    syncStatusFilterWithQuickFilters() {
      const hasQuickFilter = this.filters.progress_status.length > 0 || this.filters.is_tagged === 'true'
      this.filters.status = hasQuickFilter ? [] : ['not_closed']
    },
    onProgressStatusQuickFilterChange() {
      this.syncStatusFilterWithQuickFilters()
      this.persistFilters()
      this.fetchClaims(this.filters)
    },
    onIsTaggedQuickFilterChange(event) {
      this.filters.is_tagged = event.target.checked ? 'true' : null
      this.syncStatusFilterWithQuickFilters()
      this.persistFilters()
      this.fetchClaims(this.filters)
    },
    selectAllQuickFilter() {
      this.filters.progress_status = []
      this.filters.is_tagged = null
      this.filters.status = ['not_closed']
      this.persistFilters()
      this.fetchClaims(this.filters)
    },
    detail(data) {
      this.dataUser = data
      this.$bvModal.show('details')
    },
    async fetchClaims(filters = this.filters) {
      this.loading = true
      this.claims = []

      let data = {
        per_page: this.perPage,
        page: this.currentPage,
        url: '/list',
      }

      // Remove propriedades vazias/null do filtro
      const cleanFilters = {}
      Object.keys(filters).forEach((key) => {
        if (filters[key] != null && filters[key] !== "" && filters[key].length !== 0) {
          cleanFilters[key] = filters[key]
        }
      })

      data = Object.assign(data, cleanFilters)

      if (this.filter.length) data.search = this.filter

      await service
        .search(data)
        .then((resp) => {
          this.claims = resp.data
          const total = resp.meta && resp.meta.total ? resp.meta.total : 0
          this.totalRows = total
          this.total = total
          if (resp.meta && resp.meta.current_page) {
            localStorage.setItem('page_claim', resp.meta.current_page)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    refundClaim(dados) {
      if (!this.canRefundClaims) {
        this.$bvToast.toast('Você não tem permissão para reembolsar esta reclamação.', {
          title: 'Acesso Negado',
          variant: 'warning',
          autoHideDelay: 5000,
        });
        return;
      }

      Vue.swal({
        title: 'Reembolsar esta compra?',
        text: 'Ao clicar em confirmar, o reembolso sera efetuado!',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (
            dados.status === 'refunded' ||
            dados.status === 'refunded_automatically'
          ) {
            this.$bvToast.toast('O reembolso já foi efetuado!', {
              variant: 'warning',
              title: 'Reembolso',
              autoHideDelay: 5000,
            })
          } else {
            if (!dados.bank_code && dados.sale.method === 'BOLETO') {
              this.id_refund_item = dados.id
              this.refundClaimBoleto()
              return
            }

            this.loading = true

            service
              .create({}, `refund/${dados.id}`)
              .then(() => {
                this.$bvToast.toast('O reembolso foi efetuado!', {
                  variant: 'success',
                  title: 'Reembolso',
                  autoHideDelay: 5000,
                })
                this.fetchClaims(this.filters)
                this.$bvModal.hide('details')
                this.$bvModal.hide('modal-view-claim')
              })
              .catch((error) => {
                let errorMessage = 'Ocorreu um erro ao tentar reembolsar';

                // Verifica se a resposta do backend contém mensagens de erro
                if (error.response) {
                  errorMessage = error.response.data.sale[0];
                }
                this.$bvToast.toast(errorMessage, {
                  variant: 'danger',
                  title: 'Reembolso',
                  autoHideDelay: 5000,
                })
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
    refundClaimBoleto(account = {}) {
      this.loading = true
      service
        .create(account, `refund/${this.id_refund_item}`)
        .then(() => {
          this.$bvToast.toast('O reembolso foi efetuado!', {
            variant: 'success',
            title: 'Reembolso',
            autoHideDelay: 5000,
          })
          this.fetchClaims(this.filters)
          this.$bvModal.hide('details')
          this.$bvModal.hide('modal-view-claim')
        })
        .catch(() => {
          this.$bvToast.toast('Ocorreu um erro ao tentar reembolsar', {
            variant: 'danger',
            title: 'Reembolso',
            autoHideDelay: 5000,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    deny(dados) {
      Vue.swal({
        title: 'Recusar reembolso',
        text: 'Tem certeza que deseja recusar essa solicitação de reembolso?',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Reprovar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: dados[0],
            format: dados[1],
            status: 'DISAPPROVED',
            pending_motive: result.value,
          }

          service
            .update(data)
            .then(() => {
              this.$bvModal.hide('details')
              this.fetchClaims()
            })
            .catch(err => console.error(err))
        }
      })
    },
    login(id) {
      let url = process.env.VUE_APP_ADM_PAGE + '/admin-login/' + btoa(id)
      window.open(url)
    },
  },
}
</script>

<style lang="scss">
.actions {
  gap: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.tab-content {
  padding: 0 !important;
}

.card-box {
  border-radius: 0 0 3px 3px;
}

.due-date {
  padding: 5px;
  background: #ffca28;
  border-radius: 6px;
  font-size: 14px;
  color: white;
}
.no-due-date {
  padding: 5px;
  background: #66bb6a;
  border-radius: 6px;
  font-size: 14px;
  color: white;
}
.tag {
  padding: 5px;
  // background: ;
  border-radius: 6px;
  font-size: 14px;
  color: white;
}
.claim-list-quick-filter-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}
.claim-list-quick-filter-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
  font-size: 13px;
  color: #495057;
  cursor: pointer;
  user-select: none;
}
.claim-list-quick-filter-item input[type='checkbox'] {
  cursor: pointer;
  margin: 0;
}
.claim-list-progress-status-text {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.claim-list-status-subtext {
  font-size: 12px;
  color: #74788d;
  margin-bottom: 4px;
}
.claim-list-progress-status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  margin-right: 6px;
}
.claim-list-progress-status-primary {
  background: #556ee6;
}
.claim-list-progress-status-warning {
  background: #f1b44c;
}
.claim-list-progress-status-info {
  background: #50a5f1;
}
.claim-list-progress-status-secondary {
  background: #74788d;
}
.claim-list-progress-status-dark {
  background: #343a40;
}
</style>
